import { byIso2 } from "../assets/countries"

export const RegionLabelTransformer = (iso2: string) => {
    return byIso2[iso2]?.name ?? iso2
}
